import { Box, Button, CircularProgress, Typography, useTheme } from '@mui/material'
import { MouseEvent } from 'react'
import { useNavigate } from 'react-router-dom'

import NumberStatusSize from './NumberStatusSize'

const titleFontSize = new Map<NumberStatusSize, number>()
titleFontSize.set(NumberStatusSize.Small, 8)
titleFontSize.set(NumberStatusSize.Medium, 12)
titleFontSize.set(NumberStatusSize.Large, 16)

const dataFontSize = new Map<NumberStatusSize, number>()
dataFontSize.set(NumberStatusSize.Small, 32)
dataFontSize.set(NumberStatusSize.Medium, 48)
dataFontSize.set(NumberStatusSize.Large, 64)

const progressSize = new Map<NumberStatusSize, number>()
progressSize.set(NumberStatusSize.Small, 24)
progressSize.set(NumberStatusSize.Medium, 32)
progressSize.set(NumberStatusSize.Large, 48)

const boxSize = new Map<NumberStatusSize, number>()
boxSize.set(NumberStatusSize.Small, 96)
boxSize.set(NumberStatusSize.Medium, 160)
boxSize.set(NumberStatusSize.Large, 240)

interface NumberStatusProps {
  autoWidth?: boolean
  children?: undefined
  onClick?: (event: React.MouseEvent) => void
  size?: NumberStatusSize
  title?: string
  to?: string
  value?: number | string
}

const NumberStatus: React.FC<NumberStatusProps> = (props) => {
  const theme = useTheme()
  const { title, value, size = NumberStatusSize.Medium, autoWidth, to, onClick } = props
  const bgColorTop = theme.palette.primary.dark
  const bgColorBottom = theme.palette.primary.light
  const navigate = useNavigate()

  const fontFamily = 'Source Code Pro'

  const onLocalClick = (event: MouseEvent) => {
    if (onClick) {
      onClick(event)
    } else if (to) {
      navigate(to)
    }
  }

  return (
    <Button fullWidth onClick={onLocalClick}>
      <Box
        display="flex"
        flexDirection="column"
        flexGrow={1}
        height={autoWidth ? undefined : boxSize.get(size)}
        justifyContent="center"
        margin={1}
        width={autoWidth ? undefined : boxSize.get(size)}
      >
        <Box alignItems="center" bgcolor={bgColorTop} color={theme.palette.common.white} display="flex" flexGrow={1} justifyContent="center">
          <Typography style={{ fontFamily, fontSize: dataFontSize.get(size) }} variant="caption">
            {value === undefined ? <CircularProgress size={progressSize.get(size)} /> : value}
          </Typography>
        </Box>
        <Box bgcolor={bgColorBottom} borderTop={1} color={theme.palette.common.black} display="flex" justifyContent="center" paddingY="2px">
          <Typography noWrap style={{ fontSize: titleFontSize.get(size) }} variant="caption">
            {title}
          </Typography>
        </Box>
      </Box>
    </Button>
  )
}

export default NumberStatus
